<template>
  <v-container>
	<div class="cards">
		<card v-for="v in contents"
			:key="v.appName"
			:appDescription="v.appDescription"
			:appName="v.appName"
			:iconLink="v.iconLink"
			:color="v.color"
			:route="v.route"
		/>
	</div>
  </v-container>
</template>

<script>
import Card from './Card.vue'
export default {
	components: { Card },
	name: 'CardGrid', 
	props: ['contents'],
}
</script>

<style>
.cards {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  gap: 1rem;
}
@media (min-width: 600px) {
  .cards { grid-template-columns: repeat(2, 1fr); }
}
@media (min-width: 900px) {
  .cards { grid-template-columns: repeat(3, 1fr); }
}
</style>